import { render, staticRenderFns } from "./HomeworkDetails.vue?vue&type=template&id=3b794702&scoped=true&"
import script from "./HomeworkDetails.vue?vue&type=script&lang=js&"
export * from "./HomeworkDetails.vue?vue&type=script&lang=js&"
import style0 from "./HomeworkDetails.vue?vue&type=style&index=0&id=3b794702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b794702",
  null
  
)

export default component.exports